module.exports = __webpack_public_path__ + "img/guardados.0db9aaad.svg";